// extracted by mini-css-extract-plugin
export default {"cls1":"Avatar-cls1___7cd758c57cfe85d1cbf","cls2":"Avatar-cls2___ea460dbb01ca127dbf4 Avatar-cls1___7cd758c57cfe85d1cbf"};